/**
 * Given a diff in seconds, returns the appropriate time bucket and value.
 * This is the pure logic extracted from formatRelativeTime — no i18n dependency.
 */
export function getRelativeTimeBucket(diffInSeconds: number): {
  value: number;
  unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month';
} {
  if (diffInSeconds < 60) {
    return { value: diffInSeconds, unit: 'second' };
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return { value: diffInMinutes, unit: 'minute' };
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return { value: diffInHours, unit: 'hour' };
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return { value: diffInDays, unit: 'day' };
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return { value: diffInWeeks, unit: 'week' };
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  return { value: diffInMonths, unit: 'month' };
}

/**
 * All known support request reason codes.
 */
export const SUPPORT_REASON_CODES = [
  'payment_issue',
  'booking_issue',
  'account_issue',
  'technical_issue',
  'refund_request',
  'general_inquiry',
  'feedback',
  'other',
] as const;

export type SupportReasonCode = (typeof SUPPORT_REASON_CODES)[number];

/**
 * Returns the status badge color scheme for a support request.
 */
export function getSupportStatusColorScheme(status: string): 'orange' | 'green' {
  return status === 'pending' ? 'orange' : 'green';
}
